// Help content loader — imports every markdown file as a raw string via Vite's ?raw suffix.
// The registry references article IDs; this map resolves IDs to content strings.
// To add a new article: import its .md file here and add an entry to the HELP_CONTENT map.

import overviewMd from './overview.md?raw'
import quickStartMd from './quick-start.md?raw'
import workflowCanvasMd from './workflow-canvas.md?raw'
import toolbarActionsMd from './toolbar-actions.md?raw'
import nodeGuideMd from './node-guide.md?raw'
import resultsDeliverablesMd from './results-deliverables.md?raw'
import errorsTroubleshootingMd from './errors-troubleshooting.md?raw'
import advancedModeMd from './advanced-mode.md?raw'
import restrictionsMd from './restrictions.md?raw'
import faqMd from './faq.md?raw'
import supportMd from './support.md?raw'

// Node-specific articles
import uploadFilesMd from './nodes/upload-files.md?raw'
import codeAnalysisMd from './nodes/code-analysis.md?raw'
import codeRefactorMd from './nodes/code-refactor.md?raw'
import aiNamingMd from './nodes/ai-naming.md?raw'
import dependencyMapperMd from './nodes/dependency-mapper.md?raw'
import monolithIdentifierMd from './nodes/monolith-identifier.md?raw'
import dataAnalysisMd from './nodes/data-analysis.md?raw'
import discoveryRoiMd from './nodes/discovery-roi.md?raw'
import architectureMd from './nodes/architecture.md?raw'
import serviceGenerationMd from './nodes/service-generation.md?raw'
import preFlightMd from './nodes/pre-flight.md?raw'
import javaPackagesMd from './nodes/java-packages.md?raw'

/** @type {Record<string, string>} Map of article ID to raw markdown content */
export const HELP_CONTENT = {
  'overview':               overviewMd,
  'quick-start':            quickStartMd,
  'workflow-canvas':        workflowCanvasMd,
  'toolbar-actions':        toolbarActionsMd,
  'node-guide':             nodeGuideMd,
  'results-deliverables':   resultsDeliverablesMd,
  'errors-troubleshooting': errorsTroubleshootingMd,
  'advanced-mode':          advancedModeMd,
  'restrictions':           restrictionsMd,
  'faq':                    faqMd,
  'support':                supportMd,

  'node-upload-files':        uploadFilesMd,
  'node-code-analysis':       codeAnalysisMd,
  'node-code-refactor':       codeRefactorMd,
  'node-ai-naming':           aiNamingMd,
  'node-dependency-mapper':   dependencyMapperMd,
  'node-monolith-identifier': monolithIdentifierMd,
  'node-data-analysis':       dataAnalysisMd,
  'node-discovery-roi':       discoveryRoiMd,
  'node-architecture':        architectureMd,
  'node-service-generation':  serviceGenerationMd,
  'node-pre-flight':          preFlightMd,
  'node-java-packages':       javaPackagesMd,
}
